import PublicTeacherCertificatesTable from "./PublicTeacherCertificatesTable";

export default PublicTeacherCertificatesTable;